import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { environment } from '@environments/environment';
import { NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutesEnum } from '@shared/types';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'app-menu-profile[closePopover]',
    templateUrl: './menu-profile.component.html',
    styleUrls: ['./menu-profile.component.scss'],
    standalone: true,
    imports: [NgTemplateOutlet, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuProfileComponent {
    private auth0 = inject(AuthService);

    closePopover = output<void>();

    readonly appRoutes = AppRoutesEnum;
    readonly accountSettingsUrl = environment.accountsUrl + '/Account/Details';

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;

        await this.auth0.logout({
            openUrl(_url: string) {
                window.location.replace(url);
            },
        });
    }

    close(): void {
        this.closePopover.emit();
    }
}
